export default function customComponent(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          "&.MuiButton-root": {
            fontFamily: "PublicSans",
            transitionDuration: "150ms",
            transitionDelay: "150ms",
            textTransform:'capitalize',
            transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1);",
           
          },
          "&.MuiButton-contained": {
            backgroundColor: theme.palette.primary.main,
            color: "#fff",
            "&:active": {},
            "&:hover": {
              // transform: "translateY(0.25rem) scale(1.1);",
            },
          },
          "&.MuiButton-outlined": {
            border:'1px solid #1089FF',
            color:"#1089FF",
            "&:active": {},
          },
          "&.MuiButton-text": {
            color:'#525CEB',
            "&:active": {},
          },
          fontSize:'1rem'
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&.MuiPaper-root": {
            // boxShadow: "0px 4px 2px 0px rgba(16,137,255,0.3)",
            // padding:5,
            "&:hover": {
              // boxShadow: '0 10px 15px -3px rgba(91,131,255,0.5), 0 4px 6px -4px rgba(91,131,255,0.5)',
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&.Mui-focused": {
            // backgroundColor: theme.palette.error.main,
          },
          "&::placeholder": {
            // color: theme.darkTextSecondary,
            fontSize: "0.875rem",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "&.MuiTextField-root": {
            // marginBlock: 2,
            [theme.breakpoints.up("768")]: {
              size: "medium",
            },
          },
          "& .MuiOutlinedInput-root": {
            // backgroundColor: theme.palette.grey[50],
            "& fieldset": {
              borderColor: theme.palette.grey[300],
              borderWidth: "1.4px",
            },
            "&:hover fieldset": {
              borderColor: theme.palette.grey[800],
              borderWidth: "1.4px",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#9400FF",
              // boxShadow: "0px 0px 5px -1px rgba(148,0,255,0.31);",
              borderWidth: "1.4px",
            },
          },
          "& .MuiInputBase-input": {
            color: theme.palette.grey[800],
          },
          "& .MuiInputLabel-root": {
            color: theme.palette.grey[800],
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderRadius: theme.shape.borderRadius.main,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.MuiFormLabel-root": {
            color: theme.palette.grey[800],
            "&.Mui-focused": {
              color: theme.palette.common.black,
            },
          },
        },
      },
    },
    MuiDataGrid:{
      styleOverrides: {
        root: {
          "& .MuiDataGrid-virtualScroller": {
            overflowX:"scroll",
            scrollbarWidth: "thin",
          },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            width: "10px",
            height: "10px",
          },
          '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within':{
            outline:"none !important",
          },
          '& .MuiDataGrid-columnHeaders':{
            // backgroundColor:'#7367f0',
            // color:theme.palette.common.white,
            borderTop:`1px solid ${theme.palette.grey[200]}`,
            '&:focus':{
              outline: 'none', 
              boxShadow: 'none', 
            },
            '&:focus-within':{
              outline: 'none', 
              boxShadow: 'none', 
            }
          },
       '& .MuiDataGrid-columnHeader--withRightBorder':{
        border:'none'
       },
       '&  .MuiDataGrid-columnHeader:focus':{
        visibility:'hidden'
       },
          "&.MuiDataGrid-cell--textCenter":{
            textAlign:'center'
          },
          '&.MuiDataGrid-root .MuiDataGrid-header':{
            position: "sticky",
            top: 0,
            zIndex: 1,
          },
          '& .MuiDataGrid-menuIcon':{
            display:'none',
          },
          '&.MuiDataGrid-sortIcon':{
             display:'none',
             color:'white'
           },
           "& .MuiDataGrid-cell": {
            // borderRight:`1px solid ${theme.palette.grey[200]}`,
            borderLeft:'none',
           }
        },
        row: {
          borderBottom:`1px solid ${theme.palette.grey[200]}`,
        }
    }
  },
  MuiSwitch:{
    styleOverrides: {
      // Name of the slot
      root: {
        '&.MuiSwitch-root':{
          width: 28,
          height: 16,
          padding: 0,
          display: 'flex',
          '&:active': {
            '& .MuiSwitch-thumb': {
              width: 15,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
              transform: 'translateX(9px)',
            },
          },
          '& .MuiSwitch-switchBase': {
            padding: 2,
            '&.Mui-checked': {
              transform: 'translateX(12px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
              },
            },
          },
          '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: 12,
            height: 12,
            borderRadius: 6,
            transition: theme.transitions.create(['width'], {
              duration: 200,
            }),
          },
          '& .MuiSwitch-track': {
            borderRadius: 16 / 2,
            opacity: 1,
            backgroundColor:
              theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
            boxSizing: 'border-box',
          },
        }
      }
    }
  }
  }
}
